<div class="logo">
  <img src="assets/img/RT-Fit.png" alt="Red Thread Fit" class="logo-img">
</div>

